import { createContext, useContext } from 'react'

import type { Strategy } from '@floating-ui/core'

export type FloatingFullContextType = {
  x: number | null
  y: number | null
  strategy: Strategy
  reference: (node: HTMLElement | null) => void
  floating: (node: HTMLElement | null) => void
  update: () => void
}

export const FloatingFullContext =
  createContext<FloatingFullContextType>(undefined)

export const useFloatingFullContext = () => {
  const context = useContext(FloatingFullContext)
  if (context === undefined) {
    throw new Error('useFloating must be used within a FloatingProvider')
  }
  return context
}
